import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth0 } from '@auth0/auth0-react';
import { GameSettings } from '../types/game';
import './HomeActions.css';

interface HomeActionsProps {
  className?: string;
}

const HomeActions: React.FC<HomeActionsProps> = ({ 
  className = '' 
}) => {
  const { isAuthenticated } = useAuth0();
  
  // Define default settings (matches iOS app behavior)
  const defaultSettings: GameSettings = {
    difficulty: 'medium',      // Fixed for all users
    category: 'all',           // Fixed for all users
    questionsCount: 15,
    timePerQuestion: 15,
    autoProgress: true
  };
  return (
    <div className={`home-actions-card ${className}`}>
      {/* Decorative elements */}
      <div className="home-decoration-star"></div>
      <div className="home-decoration-star" style={{ top: '70%', left: '15%', width: '20px', height: '20px', animationDelay: '0.5s' }}></div>
      <div className="home-decoration-star" style={{ top: '20%', left: '80%', width: '15px', height: '15px', animationDelay: '1s' }}></div>
      <div className="home-decoration-circle-1"></div>
      <div className="home-decoration-circle-2"></div>
      <div className="home-decoration-line-1"></div>
      <div className="home-decoration-line-2"></div>
      <div className="home-decoration-dots"></div>
      <div className="home-decoration-dots" style={{ top: '20%', right: '10%', transform: 'rotate(-20deg)' }}></div>
      
      <div className="home-actions-content">
        <div className="home-actions-buttons">
          <Link 
            to="/play"
            state={{ 
              settings: defaultSettings,
              useProgression: isAuthenticated 
            }}
            className="home-action-btn btn-game-primary"
            aria-label="Start playing the Bible trivia game"
          >
            <span className="glowing-text">START GAME</span>
          </Link>
          <Link 
            to="/leaderboard"
            className="home-action-btn btn-game-secondary"
          >
            LEADERBOARD
          </Link>
        </div>
      </div>
    </div>
  );
};

export default HomeActions;